/**
 * aiAvailability 模块接口列表
 * AI 可用性面板 - 工单中心
 * 对接后端文档：《AI 可用性面板 - 前端对接文档》
 * 后端基础路径：/sme/agentverse/availability
 *
 * 说明：
 * - 面板为只读监控，仅包含查询类接口。
 * - 拆为两个接口：overview（健康状态 + 今日指标，整体刷新）与 fault-tickets（故障工单列表，分页 + 筛选）。
 * - 前端按 15 秒轮询自动刷新，并展示 overview.refreshTime 作为「最近刷新时间」。
 */
import $http from '../utils/http';

const aiAvailability = {
  // 面板总览（健康状态卡 + 今日核心指标）
  // GET /sme/agentverse/availability/overview （无请求参数）
  getOverview() {
    return $http.get(`${global.API_URL}/sme/agentverse/availability/overview`);
  },
  // 当前故障工单列表（分页 + 筛选）
  // GET /sme/agentverse/availability/fault-tickets
  // 支持 query 参数：companyName / ticketNumber / priority(index) / alarmTimeStart / alarmTimeEnd / pageNum / pageSize
  getFaultTickets(params) {
    return $http.get(`${global.API_URL}/sme/agentverse/availability/fault-tickets`, {
      params: params || {}
    });
  }
};

export default aiAvailability;



// WEBPACK FOOTER //
// ./src/api/aiAvailability.js